import PubSub from 'underpub-js';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

var SideNavigation = function(options) {
  this.options = {
    $el: false,
  };

  this.data = {
    baseClass: 'layout-SideNavigation',
    breakpoint: '768px',
  };

  $.extend(true, this.options, options);
};

SideNavigation.prototype.init = function() {
  const self = this;

  self.$sidebar = self.options.$el.find(`.${self.data.baseClass}__sidebar`);
  self.$content = self.options.$el.find(`.${self.data.baseClass}__content`);
  self.$navItems = self.options.$el.find(`[data-side-navigation-nav-item]`);
  self.$components = self.options.$el.find(`[data-side-navigation-component]`);

  $(window).on('load', () => {
    gsap.to(self.$sidebar, { opacity: 1, duration: 0.2 });
    self.initNavigation();
    self.initStickySidebar();
  });
};

SideNavigation.prototype.initNavigation = function() {
  const self = this;

  self.$navItems.each((index, item) => {
    const $navItem = $(item);
    const targetId = $navItem.attr('data-side-navigation-nav-item-target-id');
    const $targetComponent = self.$components
      .filter(`[data-side-navigation-component-id="${targetId}"]`)
      .one();

    const navigateToComponent = () =>
      gsap.to(window, {
        duration: 1,
        scrollTo: $targetComponent[0],
      });

    $navItem.on('click', navigateToComponent);
  });

  self.$components.each((index, item) => {
    const $component = $(item);
    const id = $component.attr('data-side-navigation-component-id');
    const $targetNavItem = self.$navItems
      .filter(`[data-side-navigation-nav-item-target-id="${id}"]`)
      .one();

    const toggleNavItemActiveState = (state) =>
      $targetNavItem.attr('data-side-navigation-nav-item-active', state);

    ScrollTrigger.create({
      trigger: $component,
      start: 'top top+=1px',
      onToggle: (self) => toggleNavItemActiveState(self.isActive),
    });
  });
};

SideNavigation.prototype.initStickySidebar = function() {
  const self = this;

  ScrollTrigger.matchMedia({
    [`(min-width: ${self.data.breakpoint})`]: function() {
      ScrollTrigger.create({
        trigger: self.$content[0],
        start: 'top top',
        invalidateOnRefresh: true,
        pin: self.$sidebar[0],
        end: 'bottom bottom',
      });
    },
  });
};

export default SideNavigation;
